var React = require('react');

function ShadowLInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"filter":"url(#filter0_f)","key":0},React.createElement("ellipse",{"cx":"574","cy":"423.5","rx":"173.5","ry":"324","transform":"rotate(-90 574 423.5)","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("filter",{"id":"filter0_f","x":"0","y":"0","width":"1148","height":"847","filterUnits":"userSpaceOnUse","colorInterpolationFilters":"sRGB"},[React.createElement("feFlood",{"floodOpacity":"0","result":"BackgroundImageFix","key":0}),React.createElement("feBlend",{"mode":"normal","in":"SourceGraphic","in2":"BackgroundImageFix","result":"shape","key":1}),React.createElement("feGaussianBlur",{"stdDeviation":"125","result":"effect1_foregroundBlur","key":2})]))]);
}

ShadowLInline.defaultProps = {"width":"1148","height":"847","viewBox":"0 0 1148 847","fill":"none"};

module.exports = ShadowLInline;

ShadowLInline.default = ShadowLInline;
